import { Component, OnInit } from "@angular/core";
import { PopoverController, NavParams, Platform } from "@ionic/angular";
import { UserSessionService } from "../../services/user-session/user-session.service";
import { CustomerModel } from "../../models/customer-model";
import { Navigator } from "../../components/menu/navigator";
import { EventsService } from "../../services/event/event.service";
import { NavOverriderService } from "../../services/navOverrider/nav-overrider.service";
import { InappService } from "src/app/services/inapp/inapp.service";
import { ConfigService } from "src/app/services/config/config.service";
import { UtilsService } from "src/app/services/utils/utils.service";
@Component({
  selector: "app-popover-marketing",
  templateUrl: "./popover-marketing.component.html",
  styleUrls: ["./popover-marketing.component.scss"],
})
export class PopoverMarketingComponent implements OnInit {
  private customer: CustomerModel;
  private triggeredNewNotification = false;
  private notificationEvent;
  private isAuthenticated = false;
  private purchaseItemConfig;
  private bannerClick = false;
  private activePopover;
  private defaultConfig = {
    priceCode: "customField7",
    credits: "customField1",
    chips: "customField3",
    points: "customField2",
    price: "customField4",
    bonusCode:"customField5"
  };
  private expectedTypes = {
    priceCode: "string",
    credits: "number",
    chips: "number",
    points: "number",
    price: "number",
    bonusCode:"string"
  };

  constructor(
    private userSession: UserSessionService,
    private popOverCtrl: PopoverController,
    private navigator: Navigator,
    private navParams: NavParams,
    private utils: UtilsService,
    private eventService: EventsService,
    private navOverride: NavOverriderService,
    private Inapp: InappService,
    private platform: Platform,
    private config: ConfigService
  ) {
    this.activePopover = this.navigator?.activePopovers[this.navigator.activePopovers.length - 1];
    this.userSession.getCustomer().subscribe((customer) => {
      this.customer = customer;
    });

    this.eventService.subscribe("event:authentication:logout", () => {
      this.closePopover();
    });
  }

  ngOnInit(): void {
    this.notificationEvent = this.navParams.data.data;
    if (this.config.getConfig().FEATURE_CAMPAIGN_PRICE_CONFIG)
      this.purchaseItemConfig = JSON.parse(
        this.config.getConfig().FEATURE_CAMPAIGN_PRICE_CONFIG
      );
    else this.purchaseItemConfig = this.defaultConfig;
    this.userSession.isAuthenticated().then(async (isAuthenticated) => {
      if (isAuthenticated) {
        this.isAuthenticated = true;
      }
    });
  }

  onBannerClick() {
    this.navOverride.setCustomCloseFunction(() => {
      this.closePopover();
    });
    this.bannerClick=true;
    const purchaseItemInfo = this.createItemInfo(this.notificationEvent);
    if (this.isAuthenticated) {
      if (this.platform.is("capacitor")) {
        return this.Inapp.purchase(purchaseItemInfo);
      }
      return this.navigator.navigateTo(
        "CreditCardComponent",
        { customModalClass: "crown-modal", backdropDismiss: true },
        { ...purchaseItemInfo }
      );
    }
  }
  createItemInfo(notificationEvent: any) {
    const newObject: { [key: string]: string | number | boolean } = {};
    for (const [newKey, originalKey] of Object.entries(
      this.purchaseItemConfig
    )) {
      if (notificationEvent.hasOwnProperty(originalKey)) {
        const value = notificationEvent[originalKey as string];
        const expectedType = this.expectedTypes[newKey];
        if (
          expectedType === "number" &&
          typeof value === "string" &&
          !isNaN(Number(value))
        ) {
          newObject[newKey] = Number(value);
        } else if (expectedType === "string" && typeof value === "string") {
          newObject[newKey] = value;
        }
      }
    }
    newObject.isAuthenticated = this.isAuthenticated;
    newObject.isSpecialOffer = true;
    if(!newObject.bonusCode && notificationEvent.campaign_code){
      newObject.bonusCode = notificationEvent.campaign_code;
    }
    if(!newObject.priceCode && notificationEvent.price_code){
      newObject.priceCode = notificationEvent.price_code;
    }
    if (!newObject.hasOwnProperty("chips")) {
      if(notificationEvent.offer_amount) {
        newObject["chips"]  = parseInt(notificationEvent.offer_amount);
      }
      if(!newObject.hasOwnProperty("chips")){
        const text = notificationEvent.text || notificationEvent.description;
        const regex =
          this.config.getConfig().FEATURE_CAMPAIGN_PRICE_REGEX ??
          /Receive\s(\d[\d,.]*)/;
        let match = text.match(regex);

        if (match) {
          const digitsOnly = match[1].replace(/\D/g, "");
          newObject["chips"] = parseInt(digitsOnly);
        }
      }
    }
    if (
      !newObject.hasOwnProperty("credits") &&
      this.config.getConfig().FEATURE_CAMPAIGN_CREDITS_REGEX
    ) {
      const text = notificationEvent.text || notificationEvent.description;
      const regex = this.config.getConfig().FEATURE_CAMPAIGN_CREDITS_REGEX;
      let match = text.match(regex);

      if (match) {
        const digitsOnly = match[1].replace(/\D/g, "");
        newObject["chips"] = parseInt(digitsOnly);
      }
    }
    return newObject;
  }

  closePopover() {
    this.navOverride.setCustomCloseFunction(undefined);
    try {
      if(this.activePopover) this.activePopover.dismiss();
    } catch (e) {
      this.popOverCtrl.dismiss();
    }
    if (!this.triggeredNewNotification) this.triggeredNewNotification = true;
    this.notificationClose();
    this.navigator.dismissAll();
  }
  notificationClose() {
    if (this.notificationEvent.onCloseFunc)
      this.notificationEvent.onCloseFunc("closeButton");
  }
  ngOnDestroy() {
    if (!this.triggeredNewNotification&&!this.bannerClick) this.notificationClose();
  }
}
